var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckSm(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.18018 0C3.78018 0 0.180176 3.6 0.180176 8C0.180176 12.4 3.78018 16 8.18018 16C12.5802 16 16.1802 12.4 16.1802 8C16.1802 3.6 12.5802 0 8.18018 0ZM11.8302 6.65L7.18018 11.3C7.03018 11.45 6.83018 11.5 6.63018 11.5C6.43018 11.5 6.23018 11.45 6.08018 11.3L4.18018 9.4C3.88018 9.1 3.88018 8.65 4.18018 8.35C4.48018 8.05 4.93018 8.05 5.23018 8.35L6.63018 9.75L10.7802 5.6C11.0802 5.3 11.5302 5.3 11.8302 5.6C12.1302 5.9 12.1302 6.35 11.8302 6.65Z",
    fill: "#6EDC5D"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSm);
export default __webpack_public_path__ + "static/media/check_sm.2b330c4448eb612b4168459a08aef189.svg";
export { ForwardRef as ReactComponent };